import { baseUrl } from '../../../boot/index.js';
import axios from 'axios';

export const createPayment = async (data) => {
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions//finance/app/v1/create-purchase-receive`, data)
    console.log({ response })
    return response

  } catch (error) {
    console.log({ error })
  }
}

export const deletePaymet = async (ROWID) => {
    console.log({ROWID})
    const token = localStorage.getItem("authToken")
    try {
      const response = await axios.delete(`${baseUrl}cleaningappfunctions//finance/app/v1/delete-purchase-receive/${ROWID}`, {
        headers: {
          "auth-token": token,
        }
      },)
      return response;
    } catch (error) {
      console.log("Error is - ",error)
      throw error
    }
  }

export const updatePayment = async (data, ROWID) => {
  console.log({ data })
  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions//finance/app/v1/update-purchase-receive/${ROWID}`, data)
    console.log({ response })
    return response

  } catch (error) {
    console.log({ error })
  }
}





export const countBilling = async (formData) => {
    const token = localStorage.getItem("authToken")
    try {
      const response = await axios.get(`${baseUrl}cleaningappfunctions/finance/app/v1/getcount-billing`, formData, {
        headers: {
          "auth-token": token,
        }
      },)
      return response;
    } catch (error) {
      throw error
    }
  }



  export const getBillingById = async (id) => {
    const token = localStorage.getItem("authToken")
    try {
      const response = await axios.get(`${baseUrl}cleaningappfunctions/finance/app/v1/gebyid-billing/${id}`, {
        headers: {
          "auth-token": token,
        }
      },)
      return response;
    } catch (error) {
      throw error
    }
  }